import { push } from 'react-router-redux';
import { fetchCategory } from './fetch-category';

export const fetchCategoryAndRedirect = (categoryId, search) => {
  return dispatch => {
    return dispatch(fetchCategory(categoryId)).then(category => {
      if (categoryId !== category._id && categoryId !== category.slug) {
        dispatch(push({ pathname: `/${category.slug}${search}`, state: 301 }));
      }
      return category;
    });
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-category-and-redirect.js